import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count:null
}
export const fetchServices = createAsyncThunk(
    "fetchServices",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/services/fetch-services-list?page=${body.page}&search=${body.search}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)



export const ServicesSlice = createSlice({
    name: 'ServicesSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchServices.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchServices.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(fetchServices.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        // builder.addCase(fetchSinglePurchasedProperty.pending, (state, action) => {
        //     state.loading = true;
        //     state.singlePurPro = null;
        // })
        // builder.addCase(fetchSinglePurchasedProperty.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.singlePurPro = action.payload;
        // })
        // builder.addCase(fetchSinglePurchasedProperty.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload?.data;
        // });

    },

})

export default ServicesSlice.reducer;